export default __webpack_public_path__ + "static/media/Picture2.a72aac6a.jpg";